<template>
  <v-card flat class="eyeCard" :loading="loading">
    <v-card-title
      class="d-flex flex-row justify-space-between py-1 px-2 mb-3 eyeTitle"
      :class="{ greenBkg: eye == 'od', blueBkg: eye == 'os' }"
    >
      {{ eyeText + " Eye" }}
      <div>
        &nbsp;
        <v-btn
          x-small
          color="red"
          @click="clearbrand()"
          class="ml-2 d-print-none"
          v-if="brand"
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-text dense class="d-flex flex-column text-center darkerCardText">
      <v-fade-transition>
        <autocomplete-all-2
          action="object"
          onlyModule="CL"
          onlyType="PRODUCT"
          @selected="brandChange($event)"
          v-if="!brand"
        ></autocomplete-all-2>
      </v-fade-transition>

      <v-fade-transition>
        <div v-if="brand" class="d-flex flex-row">
          <div class="lensImg my-1 mr-2">
            <!-- <v-img v-if="brand" :src="CL_IMAGE_DIR + brand.image" contain /> -->
            <product-image
              v-if="brand"
              :fileString="brand.image"
              type="scl"
              :maxWidth="70"
              :maxHeight="50"
              :altText="brand.name + ' product image'"
              class="mx-auto"
              position="center center"
            ></product-image>
          </div>

          <div class="font-weight-medium mx-1">
            {{ brand.name }}
            <div class="caption mt-2" v-if="brand && replaceText">
              {{ replaceText }}
            </div>
          </div>
        </div>
      </v-fade-transition>

      <v-fade-transition>
        <family-lens-selector
          v-if="!brand && priceDataForOtherEye"
          :eye="eye"
          :priceData="priceData"
          v-on:brandSelected="brandChange($event)"
          class="d-print-none"
        ></family-lens-selector>
      </v-fade-transition>
      <v-fade-transition>
        <lens-price-details
          :brand="brand"
          :priceData="priceData[eye]"
          @priceDataChange="emitPrice($event)"
          v-if="brand != null"
          class="d-print-none"
        ></lens-price-details>
      </v-fade-transition>
    </v-card-text>
  </v-card>
</template>

<script>
import LensPriceDetails from "./LensPriceDetails";
import FamilyLensSelector from "./FamilyLensSelector";
import AutocompleteAll2 from "@/components/headerStuff/AutocompleteAll-2.vue";
import QuickClAPIsMixin from "@/assets/js/cls/QuickClAPIsMixin";
import ProductImage from "@/components/clStuff/ProductImage";

import ApiServices from "@/services/ApiServices";
import FilterDictionary from "@/assets/js/cls/FilterDictionary";
import UserMixin from "@/assets/js/UserMixin";
// import HardLinksMixin from "@/assets/js/HardLinksMixin";

// todo - move the following functions somewhere more universal (they )
// import // lensImageForFile,
// replacementTextForDays,
//"./utilities/lensHelpers";

export default {
  name: "EyeLensPanel",
  components: {
    // LensSearch,
    LensPriceDetails,
    FamilyLensSelector,
    AutocompleteAll2,
    ProductImage,
    // OnlinePriceDetails,
  },
  mixins: [
    QuickClAPIsMixin,
    UserMixin,
    //  HardLinksMixin
  ],
  props: {
    eye: null,
    initialLensId: null,
    priceData: {
      // will need to extract family data: priceData[eye][meta][familyLenses]
      type: Object,
      default: function () {
        return {};
      },
    },
    brand: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      // priceDataApi: "https://www.eyedock.com/bcse/api/lens/prices/",
      // imagePath: "https://www.eyedock.com/modules/Lenses/pnimages/lens_images/",
      //brand: null,
      loading: false,
      validPriceData: null,
      // suggestionDialog: false,
      //selectedpackage: { od: null, os: null }, // will include unit price & quantity
    };
  },

  computed: {
    // todo - make this a mixin so I don't have to reuse it.
    // classForSize: function () {
    //   let daClass = "xsClass";
    //   if (this.$vuetify.breakpoint.smAndUp) daClass = "smClass";
    //   if (this.$vuetify.breakpoint.mdAndUp) daClass = "mdClass";
    //   return daClass;
    // },
    eyeText: function () {
      return this.eye == "od" ? "Right" : "Left";
    },
    otherEye: function () {
      return this.eye == "od" ? "os" : "od";
    },
    priceDataForOtherEye: function () {
      return this.priceData[this.otherEye];
    },
    isMed: function () {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    replaceText: function () {
      let days = null;
      if (this.brand.groups?.replace)
        days = parseInt(this.brand.groups.replace);
      if (this.brand?.replace) days = parseInt(this.brand.replace);
      if (!days) return null;
      // return replacementTextForDays(days) + " Replacement";
      return FilterDictionary.replaceTitleForDays(days) + " Replacement";
    },
  },

  methods: {
    // lensImageForFile,
    // replacementTextForDays,
    brandChange(val) {
      // autocomplete table has an itemId (this is the lens id). The id is the table row id and is apropos of nuthin'
      if (val?.itemId) val.id = val.itemId;
      this.$emit("brandChange", val);
      if (val) this.callDataAPI(val);
    },
    clearbrand() {
      // this.brand = null;
      this.$emit("brandChange", null);
    },

    callDataAPI(val) {
      // console.log(val);
      if (!val || !val.id) {
        // this.$emit("priceDataChange", null);
        this.emitPrice(null);
        return;
      }

      let params = null;
      if (this.auth_credentials) {
        params = this.auth_credentials;
      } else {
        alert("Please log in to use this feature");
        return;
      }

      this.loading = true;

      params.lens_id = val.id;

      ApiServices.lensPrice(params)
        .then((response) => {
          this.emitPrice(response.data);
        })
        .catch((error) => {
          console.log(error);
          this.error = "An API error occurred";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    emitPrice(price) {
      // console.log("emitting price", price);
      this.$emit("priceDataChange", price);
    },
  },
  mounted() {
    // console.log(this.initialLensId);
  },
  watch: {
    initialLensId(val) {
      // sets brand from a lens id passed to this component
      // (uses mixin)
      if (val) this.summaryForId(val, "brandChange");
    },
  },
};
</script>

<style scoped>
/* .brandName {
  max-width: 80%;
} */
/* .mdClass {
  width: 290px;
  min-height: 250px;
}
.smClass {
  width: 45%;
  min-height: 200px;
}
.xsClass {
  width: 95%;
} */

.lensImg {
  max-width: 70px;
  max-height: 50px;
}
.eyeCard {
  border: 1px solid gray;
  /* margin: 0 0.5em; */
}
.eyeTitle {
  border-bottom: 1px solid gray !important;
}

@media print {
  .mdClass,
  .smClass {
    min-height: none;
    width: 45%;
  }
}
</style>
